module.exports = __webpack_public_path__ + "static/Banner2portrait-bb5d423654e81a269d303deae8e4f095.jpg";